module.exports = function Deferred() {
  var deferred = {};
  deferred.promise = new Promise(function(resolve, reject) {
    deferred.resolve = resolve;
    deferred.reject = reject;
  });
  return deferred;
}



//////////////////
// WEBPACK FOOTER
// ./~/node-worker-pool/lib/Deferred.js
// module id = 1604
// module chunks = 0